import React from "react";

export default function RequiredAsterisk() {
	return <i className="fa-solid fa-asterisk" style={{ color: 'red' }}/>
}